import questionService from '../services/QuestionService';
import promptService from '../services/PromptService';

import { ImageLabelBehavior } from './ImageLabelBehavior';

export class ImageLabelDragDropBehavior extends ImageLabelBehavior {

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    const answerResults = lessonElementState?.currentResponseAnswer?.answerResults;
    if (answerResults && answerResults.length > 0) {
      const result = answerResults.find((r) => r.answerId === answerId);
      if (result !== undefined) {
        return Boolean(result.match);
      }
    }

    const userInputMap = lessonElementState?.currentResponseAnswer.userInputMap || questionService.updateUserInputMap({
      model,
      responseAnswer: lessonElementState.currentResponseAnswer,
      lessonElementState
    });
    const currentUserInput = userInputMap?.get(answerId);
    const currentUserInputValue = currentUserInput?.text;
    return promptService.isCorrectPromptAnswerStatus({
      dataId: answerId, currentUserInputValue, model
    });
  }

  setResponseData = (data, _responseAnswer, model, { dataId, lessonElementState, oldDataId } = {}) => {
    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({ model, lessonElementState });
      if (dataId) {
        userInputMap.set(dataId, { ...data });
      }
      if (oldDataId) {
        userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      return userInputMap;
    } else {
      if (dataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(dataId, { ...data });
      }
      if (oldDataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      return lessonElementState.currentResponseAnswer.userInputMap;
    }
  }
}

export default new ImageLabelDragDropBehavior();
